export default {

  // COMMON
  BG_COLOR: '#f3f3f3', // acl grey,
  MAIN_COLOR: '#000000', // ACL BLACK
  MAIN_INVERTED_COLOR: '#ffffff', // white
  PRIMARY_COLOR: '#20b4a8', // ACL YELLOW
  SECONDARY_COLOR: '#434244', // acl dark grey
  DESCRIPTION_COLOR: '#9FB2BE',
  ATTENTION_COLOR: '#dc3545', // red
  SUCCESS_COLOR: '#40b844', // green
  WARNING_COLOR: '#ffc107', // orange

  // OTHER
  TRANSPARENT: 'transparent'

}
